<!-- 
    UsersAndGroupsTable.vue 
    Used to show users and groups which can be selected to associate with an item
    FUTURE:  This might be something we can re-use elsewhere.  Move when we do!
-->
<script lang="ts" setup>
    import { AlignmentType, IconTypes, DisplayStyle } from '../../Enums/UiEnums';
    import { ICol, RenderModeType } from '../../lib/ChoiceTableHelpers';
    import { DatabaseIdTypes } from '../../Enums/ChoiceEnums';
    import { commonName } from '../../lib/Formatting/DatabaseIdTypeInfo';
    import { ISelection } from '../../lib/Models/Selection';
    import { watch, ref, onMounted } from 'vue';
    import ChoiceTable from "../../components/ChoiceTable.vue";
    import DatabaseIdType from "../../components/DatabaseIdType.vue"
    import Icon from '../../components/Icon.vue'
    import { IUserAndGroupTableItem } from '../../lib/Models/User/UserAndGroupItem';
    import { IDatabaseIdModel } from '../../lib/Models/DatabaseIdModel';
    import _ from 'lodash';

    const props = withDefaults(defineProps<{
        usersAndGroups: (IUserAndGroupTableItem & ISelection)[],
        selectedusersAndGroupsIds?: IDatabaseIdModel[]
    }>(), {});

    const emit = defineEmits<{
        (e: "update:selectedusersAndGroupsIds", selectedIds: IDatabaseIdModel[]): void
    }>();

    const usersAndGroupsTableData = ref<(IUserAndGroupTableItem & ISelection)[]>();

    watch(() => props.usersAndGroups, (newVal, oldVal) => {
        usersAndGroupsTableData.value = Array.from(newVal);
    });

    // Update items with a key value
    watch(() => props.selectedusersAndGroupsIds, (newVal, oldVal) =>{

        updateSelections(newVal);
    });

    onMounted(()=>{
        usersAndGroupsTableData.value = Array.from(props.usersAndGroups);
        updateSelections(props.selectedusersAndGroupsIds);
    });


    const columnsUsersAndGroupsTable: ICol[] = [
            { Name: "", DataField: "selected", RenderMode: RenderModeType.Selection, Alignment: AlignmentType.Center },
            { Name:"", DataField: "isFavorite", HideFilter: true, Alignment: AlignmentType.Center },
            { Name: "Name", DataField:"name" },
            { 
                Name: "Type", 
                DataField:"idType",
                FilterValue: (value: any) => {
                    return commonName(value as DatabaseIdTypes);}
            }
        ];

    function updateSelections(selectedItems?: IDatabaseIdModel[])
    {
        for(const audienceItem of props.usersAndGroups)
        {
            audienceItem.keyValueDataMember = `${audienceItem.id}:${audienceItem.idType}`;

            if (selectedItems)
            {
                const isSelected = !!selectedItems.find(itemId => itemId.id === audienceItem.id && itemId.idType === audienceItem.idType);
                audienceItem.selected = isSelected;
            }
        }
    }

    function onSelectChanged(checked: boolean|undefined, colData: ICol, row?: Record<string, any>)
    {
        // Handle a single row or all rows        
        if (row)
        {
            const tempValues = [...(props.selectedusersAndGroupsIds??[])];

            const idValue = { id: +row["id"], idType: row["idType"]};
            if (checked)
                tempValues.push(idValue);
            else
                _.remove(tempValues, i => i.id == idValue.id && i.idType == idValue.idType);

            emit("update:selectedusersAndGroupsIds", Array.from(tempValues));
        }    
        else
        {
            if (checked)
            {
                const allItems = props.usersAndGroups.map(item => { return { id: item.id, idType: item.idType }});
                emit("update:selectedusersAndGroupsIds", allItems);
            }
            else
                emit("update:selectedusersAndGroupsIds", []);
        }
    }
</script>

<template>
    <!-- Users/Groups -->
    <ChoiceTable 
        :columns="columnsUsersAndGroupsTable"
        :data="usersAndGroupsTableData"
        :allow-sorting="true"
        :show-filters="true"
        keyValueDataMember="keyValueDataMember"
        @selectChanged="onSelectChanged">
        <template #cell="{col, row, value}">
            <template v-if="'isFavorite' === col.DataField">
                <Icon v-if="true === value" :icon="IconTypes.Star" :displayStyle="DisplayStyle.Warning" title="Favorite"/>
            </template>
            <template v-if="'idType' === col.DataField">
                <DatabaseIdType :idType="value" />
            </template>
        </template>
    </ChoiceTable>    

</template>